import mixpanel from 'mixpanel-browser'

mixpanel.init('7a198afea4ddcbaca3e4a00544a8864e')
export { mixpanel }
